<script setup lang="ts">
import { computed } from 'vue'
import { Position, Handle } from '@vue-flow/core'
import type { NodeProps } from '@vue-flow/core'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faShield, faBan, faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons'
import { buildComponentClasses, buildTooltipMessage, getStepColors } from '@/composables/stepStyles'

library.add(faShield, faBan, faTriangleExclamation)

const props = defineProps<NodeProps>()

// we will integrate a little more logic here to set border color and icons based on node data
const stepStyle = computed(() => getStepColors(props.data.status))
const errorMessage = computed(() => buildTooltipMessage(props.data?.errors))
const componentClasses = computed(() => buildComponentClasses(props.data.isSelected, stepStyle.value))
</script>

<template>
	<div v-if="stepStyle.icons.length > 0" v-tooltip="{
		value: errorMessage,
		escape: false,
		pt: {
			arrow: [stepStyle.border.right.primary, stepStyle.border.left.primary],
			text: stepStyle.background.primary,
		},
	}" class="absolute -top-4 -right-4 cursor-pointer">
		<FontAwesomeIcon v-for="icon in stepStyle.icons" :key="icon" :icon="['far', icon]"
			class="w-4 h-4 p-1 border-2 rounded-full" :class="componentClasses.iconClasses" />
	</div>
	<div
		class="flex text-center w-full h-full rounded-md border border-solid cursor-pointer" :class="componentClasses.divClasses"
		v-tooltip="props.data.tooltip">
		<!-- Left double border -->
		<div class="left-0 top-0 h-full w-3 border-r border-solid" :class="componentClasses.divClasses" />
		<div class="flex-grow py-2"><span class="flex items-center justify-center w-full h-full">{{ data.label }}</span></div>
		<!-- Bottom double border -->
		<!-- Right double border -->
		<div class="right-0 top-0 h-full w-3 border-l border-solid" :class="componentClasses.divClasses" />
		<!-- The node connection point for input -->
		<Handle v-if="data.isTarget" type="target" :position="Position.Top" />
		<!-- The node connection point for output -->
		<Handle v-if="data.isSource" type="source" :position="Position.Bottom" />
	</div>
</template>